/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthAuthLayoutRouteImport } from './routes/auth/_auth-layout'
import { Route as appMainLayoutRouteImport } from './routes/(app)/_main-layout'
import { Route as appAdminLayoutRouteImport } from './routes/(app)/_admin-layout'
import { Route as AuthAuthLayoutSignupRouteImport } from './routes/auth/_auth-layout/signup_'
import { Route as AuthAuthLayoutSigninRouteImport } from './routes/auth/_auth-layout/signin'
import { Route as AuthAuthLayoutForgotPasswordRouteImport } from './routes/auth/_auth-layout/forgot-password'
import { Route as appAdminLayoutAdminRouteImport } from './routes/(app)/_admin-layout/admin'
import { Route as appMainLayoutDashboardIndexRouteImport } from './routes/(app)/_main-layout/_dashboard/index'
import { Route as AuthAuthLayoutVerifyOtpOtpRequestIdRouteImport } from './routes/auth/_auth-layout/verify-otp/$otpRequestId'
import { Route as AuthAuthLayoutSignupSuccessRouteImport } from './routes/auth/_auth-layout/signup.success'
import { Route as AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRouteImport } from './routes/auth/_auth-layout/set-two-factor/$twoFactorRequestId'
import { Route as AuthAuthLayoutResetPasswordTokenRouteImport } from './routes/auth/_auth-layout/reset-password/$token'
import { Route as appMainLayoutSettingsSettingsRouteImport } from './routes/(app)/_main-layout/_settings/settings'
import { Route as appMainLayoutPaymentsPaymentsRouteImport } from './routes/(app)/_main-layout/_payments/payments'
import { Route as appMainLayoutPayByLinkPayByLinkRouteImport } from './routes/(app)/_main-layout/_pay-by-link/pay-by-link'
import { Route as appMainLayoutExchangeExchangeRouteImport } from './routes/(app)/_main-layout/_exchange/exchange'
import { Route as appMainLayoutBalancesBalancesRouteImport } from './routes/(app)/_main-layout/_balances/balances'
import { Route as appAdminLayoutAdminPaymentsRouteImport } from './routes/(app)/_admin-layout/admin_.payments'
import { Route as appMainLayoutSettingsSettingsWebhooksCallbacksRouteImport } from './routes/(app)/_main-layout/_settings/settings.webhooks-callbacks'
import { Route as appMainLayoutSettingsSettingsUsersRouteImport } from './routes/(app)/_main-layout/_settings/settings.users'
import { Route as appMainLayoutSettingsSettingsSecurityRouteImport } from './routes/(app)/_main-layout/_settings/settings.security'
import { Route as appMainLayoutSettingsSettingsNotificationsRouteImport } from './routes/(app)/_main-layout/_settings/settings.notifications'
import { Route as appMainLayoutSettingsSettingsInstitutionsRouteImport } from './routes/(app)/_main-layout/_settings/settings.institutions'
import { Route as appMainLayoutSettingsSettingsAccountsRouteImport } from './routes/(app)/_main-layout/_settings/settings.accounts'
import { Route as appMainLayoutSettingsSettingsAccountSettingsRouteImport } from './routes/(app)/_main-layout/_settings/settings.account-settings'
import { Route as appMainLayoutPaymentsPaymentsPaymentIdRouteImport } from './routes/(app)/_main-layout/_payments/payments_.$paymentId'
import { Route as appMainLayoutPaymentsPaymentsPayoutRouteImport } from './routes/(app)/_main-layout/_payments/payments.payout'
import { Route as appMainLayoutPaymentsPaymentsPayinRouteImport } from './routes/(app)/_main-layout/_payments/payments.payin'
import { Route as appMainLayoutPayByLinkPayByLinkPaymentIntentIdRouteImport } from './routes/(app)/_main-layout/_pay-by-link/pay-by-link_.$paymentIntentId'
import { Route as appMainLayoutBalancesBalancesOverviewRouteImport } from './routes/(app)/_main-layout/_balances/balances.overview'
import { Route as appAdminLayoutAdminPaymentsPaymentIdRouteImport } from './routes/(app)/_admin-layout/admin_.payments_.$paymentId'
import { Route as appAdminLayoutAdminMerchantsMerchantIdRouteImport } from './routes/(app)/_admin-layout/admin_.merchants_.$merchantId'

const AuthRouteImport = createFileRoute('/auth')()
const appRouteImport = createFileRoute('/(app)')()

const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const appRoute = appRouteImport.update({
  id: '/(app)',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAuthLayoutRoute = AuthAuthLayoutRouteImport.update({
  id: '/_auth-layout',
  getParentRoute: () => AuthRoute,
} as any)
const appMainLayoutRoute = appMainLayoutRouteImport.update({
  id: '/_main-layout',
  getParentRoute: () => appRoute,
} as any)
const appAdminLayoutRoute = appAdminLayoutRouteImport.update({
  id: '/_admin-layout',
  getParentRoute: () => appRoute,
} as any)
const AuthAuthLayoutSignupRoute = AuthAuthLayoutSignupRouteImport.update({
  id: '/signup_',
  path: '/signup',
  getParentRoute: () => AuthAuthLayoutRoute,
} as any)
const AuthAuthLayoutSigninRoute = AuthAuthLayoutSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => AuthAuthLayoutRoute,
} as any)
const AuthAuthLayoutForgotPasswordRoute =
  AuthAuthLayoutForgotPasswordRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => AuthAuthLayoutRoute,
  } as any)
const appAdminLayoutAdminRoute = appAdminLayoutAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => appAdminLayoutRoute,
} as any)
const appMainLayoutDashboardIndexRoute =
  appMainLayoutDashboardIndexRouteImport.update({
    id: '/_dashboard/',
    path: '/',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const AuthAuthLayoutVerifyOtpOtpRequestIdRoute =
  AuthAuthLayoutVerifyOtpOtpRequestIdRouteImport.update({
    id: '/verify-otp/$otpRequestId',
    path: '/verify-otp/$otpRequestId',
    getParentRoute: () => AuthAuthLayoutRoute,
  } as any)
const AuthAuthLayoutSignupSuccessRoute =
  AuthAuthLayoutSignupSuccessRouteImport.update({
    id: '/signup/success',
    path: '/signup/success',
    getParentRoute: () => AuthAuthLayoutRoute,
  } as any)
const AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRoute =
  AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRouteImport.update({
    id: '/set-two-factor/$twoFactorRequestId',
    path: '/set-two-factor/$twoFactorRequestId',
    getParentRoute: () => AuthAuthLayoutRoute,
  } as any)
const AuthAuthLayoutResetPasswordTokenRoute =
  AuthAuthLayoutResetPasswordTokenRouteImport.update({
    id: '/reset-password/$token',
    path: '/reset-password/$token',
    getParentRoute: () => AuthAuthLayoutRoute,
  } as any)
const appMainLayoutSettingsSettingsRoute =
  appMainLayoutSettingsSettingsRouteImport.update({
    id: '/_settings/settings',
    path: '/settings',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const appMainLayoutPaymentsPaymentsRoute =
  appMainLayoutPaymentsPaymentsRouteImport.update({
    id: '/_payments/payments',
    path: '/payments',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const appMainLayoutPayByLinkPayByLinkRoute =
  appMainLayoutPayByLinkPayByLinkRouteImport.update({
    id: '/_pay-by-link/pay-by-link',
    path: '/pay-by-link',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const appMainLayoutExchangeExchangeRoute =
  appMainLayoutExchangeExchangeRouteImport.update({
    id: '/_exchange/exchange',
    path: '/exchange',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const appMainLayoutBalancesBalancesRoute =
  appMainLayoutBalancesBalancesRouteImport.update({
    id: '/_balances/balances',
    path: '/balances',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const appAdminLayoutAdminPaymentsRoute =
  appAdminLayoutAdminPaymentsRouteImport.update({
    id: '/admin_/payments',
    path: '/admin/payments',
    getParentRoute: () => appAdminLayoutRoute,
  } as any)
const appMainLayoutSettingsSettingsWebhooksCallbacksRoute =
  appMainLayoutSettingsSettingsWebhooksCallbacksRouteImport.update({
    id: '/webhooks-callbacks',
    path: '/webhooks-callbacks',
    getParentRoute: () => appMainLayoutSettingsSettingsRoute,
  } as any)
const appMainLayoutSettingsSettingsUsersRoute =
  appMainLayoutSettingsSettingsUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => appMainLayoutSettingsSettingsRoute,
  } as any)
const appMainLayoutSettingsSettingsSecurityRoute =
  appMainLayoutSettingsSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => appMainLayoutSettingsSettingsRoute,
  } as any)
const appMainLayoutSettingsSettingsNotificationsRoute =
  appMainLayoutSettingsSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => appMainLayoutSettingsSettingsRoute,
  } as any)
const appMainLayoutSettingsSettingsInstitutionsRoute =
  appMainLayoutSettingsSettingsInstitutionsRouteImport.update({
    id: '/institutions',
    path: '/institutions',
    getParentRoute: () => appMainLayoutSettingsSettingsRoute,
  } as any)
const appMainLayoutSettingsSettingsAccountsRoute =
  appMainLayoutSettingsSettingsAccountsRouteImport.update({
    id: '/accounts',
    path: '/accounts',
    getParentRoute: () => appMainLayoutSettingsSettingsRoute,
  } as any)
const appMainLayoutSettingsSettingsAccountSettingsRoute =
  appMainLayoutSettingsSettingsAccountSettingsRouteImport.update({
    id: '/account-settings',
    path: '/account-settings',
    getParentRoute: () => appMainLayoutSettingsSettingsRoute,
  } as any)
const appMainLayoutPaymentsPaymentsPaymentIdRoute =
  appMainLayoutPaymentsPaymentsPaymentIdRouteImport.update({
    id: '/_payments/payments_/$paymentId',
    path: '/payments/$paymentId',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const appMainLayoutPaymentsPaymentsPayoutRoute =
  appMainLayoutPaymentsPaymentsPayoutRouteImport.update({
    id: '/payout',
    path: '/payout',
    getParentRoute: () => appMainLayoutPaymentsPaymentsRoute,
  } as any)
const appMainLayoutPaymentsPaymentsPayinRoute =
  appMainLayoutPaymentsPaymentsPayinRouteImport.update({
    id: '/payin',
    path: '/payin',
    getParentRoute: () => appMainLayoutPaymentsPaymentsRoute,
  } as any)
const appMainLayoutPayByLinkPayByLinkPaymentIntentIdRoute =
  appMainLayoutPayByLinkPayByLinkPaymentIntentIdRouteImport.update({
    id: '/_pay-by-link/pay-by-link_/$paymentIntentId',
    path: '/pay-by-link/$paymentIntentId',
    getParentRoute: () => appMainLayoutRoute,
  } as any)
const appMainLayoutBalancesBalancesOverviewRoute =
  appMainLayoutBalancesBalancesOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => appMainLayoutBalancesBalancesRoute,
  } as any)
const appAdminLayoutAdminPaymentsPaymentIdRoute =
  appAdminLayoutAdminPaymentsPaymentIdRouteImport.update({
    id: '/admin_/payments_/$paymentId',
    path: '/admin/payments/$paymentId',
    getParentRoute: () => appAdminLayoutRoute,
  } as any)
const appAdminLayoutAdminMerchantsMerchantIdRoute =
  appAdminLayoutAdminMerchantsMerchantIdRouteImport.update({
    id: '/admin_/merchants_/$merchantId',
    path: '/admin/merchants/$merchantId',
    getParentRoute: () => appAdminLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/about': typeof AboutRoute
  '/error': typeof ErrorRoute
  '/': typeof appMainLayoutDashboardIndexRoute
  '/auth': typeof AuthAuthLayoutRouteWithChildren
  '/admin': typeof appAdminLayoutAdminRoute
  '/auth/forgot-password': typeof AuthAuthLayoutForgotPasswordRoute
  '/auth/signin': typeof AuthAuthLayoutSigninRoute
  '/auth/signup': typeof AuthAuthLayoutSignupRoute
  '/admin/payments': typeof appAdminLayoutAdminPaymentsRoute
  '/balances': typeof appMainLayoutBalancesBalancesRouteWithChildren
  '/exchange': typeof appMainLayoutExchangeExchangeRoute
  '/pay-by-link': typeof appMainLayoutPayByLinkPayByLinkRoute
  '/payments': typeof appMainLayoutPaymentsPaymentsRouteWithChildren
  '/settings': typeof appMainLayoutSettingsSettingsRouteWithChildren
  '/auth/reset-password/$token': typeof AuthAuthLayoutResetPasswordTokenRoute
  '/auth/set-two-factor/$twoFactorRequestId': typeof AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRoute
  '/auth/signup/success': typeof AuthAuthLayoutSignupSuccessRoute
  '/auth/verify-otp/$otpRequestId': typeof AuthAuthLayoutVerifyOtpOtpRequestIdRoute
  '/admin/merchants/$merchantId': typeof appAdminLayoutAdminMerchantsMerchantIdRoute
  '/admin/payments/$paymentId': typeof appAdminLayoutAdminPaymentsPaymentIdRoute
  '/balances/overview': typeof appMainLayoutBalancesBalancesOverviewRoute
  '/pay-by-link/$paymentIntentId': typeof appMainLayoutPayByLinkPayByLinkPaymentIntentIdRoute
  '/payments/payin': typeof appMainLayoutPaymentsPaymentsPayinRoute
  '/payments/payout': typeof appMainLayoutPaymentsPaymentsPayoutRoute
  '/payments/$paymentId': typeof appMainLayoutPaymentsPaymentsPaymentIdRoute
  '/settings/account-settings': typeof appMainLayoutSettingsSettingsAccountSettingsRoute
  '/settings/accounts': typeof appMainLayoutSettingsSettingsAccountsRoute
  '/settings/institutions': typeof appMainLayoutSettingsSettingsInstitutionsRoute
  '/settings/notifications': typeof appMainLayoutSettingsSettingsNotificationsRoute
  '/settings/security': typeof appMainLayoutSettingsSettingsSecurityRoute
  '/settings/users': typeof appMainLayoutSettingsSettingsUsersRoute
  '/settings/webhooks-callbacks': typeof appMainLayoutSettingsSettingsWebhooksCallbacksRoute
}
export interface FileRoutesByTo {
  '/about': typeof AboutRoute
  '/error': typeof ErrorRoute
  '/': typeof appMainLayoutDashboardIndexRoute
  '/auth': typeof AuthAuthLayoutRouteWithChildren
  '/admin': typeof appAdminLayoutAdminRoute
  '/auth/forgot-password': typeof AuthAuthLayoutForgotPasswordRoute
  '/auth/signin': typeof AuthAuthLayoutSigninRoute
  '/auth/signup': typeof AuthAuthLayoutSignupRoute
  '/admin/payments': typeof appAdminLayoutAdminPaymentsRoute
  '/balances': typeof appMainLayoutBalancesBalancesRouteWithChildren
  '/exchange': typeof appMainLayoutExchangeExchangeRoute
  '/pay-by-link': typeof appMainLayoutPayByLinkPayByLinkRoute
  '/payments': typeof appMainLayoutPaymentsPaymentsRouteWithChildren
  '/settings': typeof appMainLayoutSettingsSettingsRouteWithChildren
  '/auth/reset-password/$token': typeof AuthAuthLayoutResetPasswordTokenRoute
  '/auth/set-two-factor/$twoFactorRequestId': typeof AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRoute
  '/auth/signup/success': typeof AuthAuthLayoutSignupSuccessRoute
  '/auth/verify-otp/$otpRequestId': typeof AuthAuthLayoutVerifyOtpOtpRequestIdRoute
  '/admin/merchants/$merchantId': typeof appAdminLayoutAdminMerchantsMerchantIdRoute
  '/admin/payments/$paymentId': typeof appAdminLayoutAdminPaymentsPaymentIdRoute
  '/balances/overview': typeof appMainLayoutBalancesBalancesOverviewRoute
  '/pay-by-link/$paymentIntentId': typeof appMainLayoutPayByLinkPayByLinkPaymentIntentIdRoute
  '/payments/payin': typeof appMainLayoutPaymentsPaymentsPayinRoute
  '/payments/payout': typeof appMainLayoutPaymentsPaymentsPayoutRoute
  '/payments/$paymentId': typeof appMainLayoutPaymentsPaymentsPaymentIdRoute
  '/settings/account-settings': typeof appMainLayoutSettingsSettingsAccountSettingsRoute
  '/settings/accounts': typeof appMainLayoutSettingsSettingsAccountsRoute
  '/settings/institutions': typeof appMainLayoutSettingsSettingsInstitutionsRoute
  '/settings/notifications': typeof appMainLayoutSettingsSettingsNotificationsRoute
  '/settings/security': typeof appMainLayoutSettingsSettingsSecurityRoute
  '/settings/users': typeof appMainLayoutSettingsSettingsUsersRoute
  '/settings/webhooks-callbacks': typeof appMainLayoutSettingsSettingsWebhooksCallbacksRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/about': typeof AboutRoute
  '/error': typeof ErrorRoute
  '/(app)': typeof appRouteWithChildren
  '/(app)/_admin-layout': typeof appAdminLayoutRouteWithChildren
  '/(app)/_main-layout': typeof appMainLayoutRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/auth/_auth-layout': typeof AuthAuthLayoutRouteWithChildren
  '/(app)/_admin-layout/admin': typeof appAdminLayoutAdminRoute
  '/auth/_auth-layout/forgot-password': typeof AuthAuthLayoutForgotPasswordRoute
  '/auth/_auth-layout/signin': typeof AuthAuthLayoutSigninRoute
  '/auth/_auth-layout/signup_': typeof AuthAuthLayoutSignupRoute
  '/(app)/_admin-layout/admin_/payments': typeof appAdminLayoutAdminPaymentsRoute
  '/(app)/_main-layout/_balances/balances': typeof appMainLayoutBalancesBalancesRouteWithChildren
  '/(app)/_main-layout/_exchange/exchange': typeof appMainLayoutExchangeExchangeRoute
  '/(app)/_main-layout/_pay-by-link/pay-by-link': typeof appMainLayoutPayByLinkPayByLinkRoute
  '/(app)/_main-layout/_payments/payments': typeof appMainLayoutPaymentsPaymentsRouteWithChildren
  '/(app)/_main-layout/_settings/settings': typeof appMainLayoutSettingsSettingsRouteWithChildren
  '/auth/_auth-layout/reset-password/$token': typeof AuthAuthLayoutResetPasswordTokenRoute
  '/auth/_auth-layout/set-two-factor/$twoFactorRequestId': typeof AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRoute
  '/auth/_auth-layout/signup/success': typeof AuthAuthLayoutSignupSuccessRoute
  '/auth/_auth-layout/verify-otp/$otpRequestId': typeof AuthAuthLayoutVerifyOtpOtpRequestIdRoute
  '/(app)/_main-layout/_dashboard/': typeof appMainLayoutDashboardIndexRoute
  '/(app)/_admin-layout/admin_/merchants_/$merchantId': typeof appAdminLayoutAdminMerchantsMerchantIdRoute
  '/(app)/_admin-layout/admin_/payments_/$paymentId': typeof appAdminLayoutAdminPaymentsPaymentIdRoute
  '/(app)/_main-layout/_balances/balances/overview': typeof appMainLayoutBalancesBalancesOverviewRoute
  '/(app)/_main-layout/_pay-by-link/pay-by-link_/$paymentIntentId': typeof appMainLayoutPayByLinkPayByLinkPaymentIntentIdRoute
  '/(app)/_main-layout/_payments/payments/payin': typeof appMainLayoutPaymentsPaymentsPayinRoute
  '/(app)/_main-layout/_payments/payments/payout': typeof appMainLayoutPaymentsPaymentsPayoutRoute
  '/(app)/_main-layout/_payments/payments_/$paymentId': typeof appMainLayoutPaymentsPaymentsPaymentIdRoute
  '/(app)/_main-layout/_settings/settings/account-settings': typeof appMainLayoutSettingsSettingsAccountSettingsRoute
  '/(app)/_main-layout/_settings/settings/accounts': typeof appMainLayoutSettingsSettingsAccountsRoute
  '/(app)/_main-layout/_settings/settings/institutions': typeof appMainLayoutSettingsSettingsInstitutionsRoute
  '/(app)/_main-layout/_settings/settings/notifications': typeof appMainLayoutSettingsSettingsNotificationsRoute
  '/(app)/_main-layout/_settings/settings/security': typeof appMainLayoutSettingsSettingsSecurityRoute
  '/(app)/_main-layout/_settings/settings/users': typeof appMainLayoutSettingsSettingsUsersRoute
  '/(app)/_main-layout/_settings/settings/webhooks-callbacks': typeof appMainLayoutSettingsSettingsWebhooksCallbacksRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/about'
    | '/error'
    | '/'
    | '/auth'
    | '/admin'
    | '/auth/forgot-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/admin/payments'
    | '/balances'
    | '/exchange'
    | '/pay-by-link'
    | '/payments'
    | '/settings'
    | '/auth/reset-password/$token'
    | '/auth/set-two-factor/$twoFactorRequestId'
    | '/auth/signup/success'
    | '/auth/verify-otp/$otpRequestId'
    | '/admin/merchants/$merchantId'
    | '/admin/payments/$paymentId'
    | '/balances/overview'
    | '/pay-by-link/$paymentIntentId'
    | '/payments/payin'
    | '/payments/payout'
    | '/payments/$paymentId'
    | '/settings/account-settings'
    | '/settings/accounts'
    | '/settings/institutions'
    | '/settings/notifications'
    | '/settings/security'
    | '/settings/users'
    | '/settings/webhooks-callbacks'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/about'
    | '/error'
    | '/'
    | '/auth'
    | '/admin'
    | '/auth/forgot-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/admin/payments'
    | '/balances'
    | '/exchange'
    | '/pay-by-link'
    | '/payments'
    | '/settings'
    | '/auth/reset-password/$token'
    | '/auth/set-two-factor/$twoFactorRequestId'
    | '/auth/signup/success'
    | '/auth/verify-otp/$otpRequestId'
    | '/admin/merchants/$merchantId'
    | '/admin/payments/$paymentId'
    | '/balances/overview'
    | '/pay-by-link/$paymentIntentId'
    | '/payments/payin'
    | '/payments/payout'
    | '/payments/$paymentId'
    | '/settings/account-settings'
    | '/settings/accounts'
    | '/settings/institutions'
    | '/settings/notifications'
    | '/settings/security'
    | '/settings/users'
    | '/settings/webhooks-callbacks'
  id:
    | '__root__'
    | '/about'
    | '/error'
    | '/(app)'
    | '/(app)/_admin-layout'
    | '/(app)/_main-layout'
    | '/auth'
    | '/auth/_auth-layout'
    | '/(app)/_admin-layout/admin'
    | '/auth/_auth-layout/forgot-password'
    | '/auth/_auth-layout/signin'
    | '/auth/_auth-layout/signup_'
    | '/(app)/_admin-layout/admin_/payments'
    | '/(app)/_main-layout/_balances/balances'
    | '/(app)/_main-layout/_exchange/exchange'
    | '/(app)/_main-layout/_pay-by-link/pay-by-link'
    | '/(app)/_main-layout/_payments/payments'
    | '/(app)/_main-layout/_settings/settings'
    | '/auth/_auth-layout/reset-password/$token'
    | '/auth/_auth-layout/set-two-factor/$twoFactorRequestId'
    | '/auth/_auth-layout/signup/success'
    | '/auth/_auth-layout/verify-otp/$otpRequestId'
    | '/(app)/_main-layout/_dashboard/'
    | '/(app)/_admin-layout/admin_/merchants_/$merchantId'
    | '/(app)/_admin-layout/admin_/payments_/$paymentId'
    | '/(app)/_main-layout/_balances/balances/overview'
    | '/(app)/_main-layout/_pay-by-link/pay-by-link_/$paymentIntentId'
    | '/(app)/_main-layout/_payments/payments/payin'
    | '/(app)/_main-layout/_payments/payments/payout'
    | '/(app)/_main-layout/_payments/payments_/$paymentId'
    | '/(app)/_main-layout/_settings/settings/account-settings'
    | '/(app)/_main-layout/_settings/settings/accounts'
    | '/(app)/_main-layout/_settings/settings/institutions'
    | '/(app)/_main-layout/_settings/settings/notifications'
    | '/(app)/_main-layout/_settings/settings/security'
    | '/(app)/_main-layout/_settings/settings/users'
    | '/(app)/_main-layout/_settings/settings/webhooks-callbacks'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AboutRoute: typeof AboutRoute
  ErrorRoute: typeof ErrorRoute
  appRoute: typeof appRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)': {
      id: '/(app)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/_auth-layout': {
      id: '/auth/_auth-layout'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthAuthLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/(app)/_main-layout': {
      id: '/(app)/_main-layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof appMainLayoutRouteImport
      parentRoute: typeof appRoute
    }
    '/(app)/_admin-layout': {
      id: '/(app)/_admin-layout'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appAdminLayoutRouteImport
      parentRoute: typeof appRoute
    }
    '/auth/_auth-layout/signup_': {
      id: '/auth/_auth-layout/signup_'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthAuthLayoutSignupRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/auth/_auth-layout/signin': {
      id: '/auth/_auth-layout/signin'
      path: '/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthAuthLayoutSigninRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/auth/_auth-layout/forgot-password': {
      id: '/auth/_auth-layout/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthAuthLayoutForgotPasswordRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/(app)/_admin-layout/admin': {
      id: '/(app)/_admin-layout/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof appAdminLayoutAdminRouteImport
      parentRoute: typeof appAdminLayoutRoute
    }
    '/(app)/_main-layout/_dashboard/': {
      id: '/(app)/_main-layout/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appMainLayoutDashboardIndexRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/auth/_auth-layout/verify-otp/$otpRequestId': {
      id: '/auth/_auth-layout/verify-otp/$otpRequestId'
      path: '/verify-otp/$otpRequestId'
      fullPath: '/auth/verify-otp/$otpRequestId'
      preLoaderRoute: typeof AuthAuthLayoutVerifyOtpOtpRequestIdRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/auth/_auth-layout/signup/success': {
      id: '/auth/_auth-layout/signup/success'
      path: '/signup/success'
      fullPath: '/auth/signup/success'
      preLoaderRoute: typeof AuthAuthLayoutSignupSuccessRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/auth/_auth-layout/set-two-factor/$twoFactorRequestId': {
      id: '/auth/_auth-layout/set-two-factor/$twoFactorRequestId'
      path: '/set-two-factor/$twoFactorRequestId'
      fullPath: '/auth/set-two-factor/$twoFactorRequestId'
      preLoaderRoute: typeof AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/auth/_auth-layout/reset-password/$token': {
      id: '/auth/_auth-layout/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/auth/reset-password/$token'
      preLoaderRoute: typeof AuthAuthLayoutResetPasswordTokenRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/(app)/_main-layout/_settings/settings': {
      id: '/(app)/_main-layout/_settings/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof appMainLayoutSettingsSettingsRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_main-layout/_payments/payments': {
      id: '/(app)/_main-layout/_payments/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof appMainLayoutPaymentsPaymentsRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_main-layout/_pay-by-link/pay-by-link': {
      id: '/(app)/_main-layout/_pay-by-link/pay-by-link'
      path: '/pay-by-link'
      fullPath: '/pay-by-link'
      preLoaderRoute: typeof appMainLayoutPayByLinkPayByLinkRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_main-layout/_exchange/exchange': {
      id: '/(app)/_main-layout/_exchange/exchange'
      path: '/exchange'
      fullPath: '/exchange'
      preLoaderRoute: typeof appMainLayoutExchangeExchangeRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_main-layout/_balances/balances': {
      id: '/(app)/_main-layout/_balances/balances'
      path: '/balances'
      fullPath: '/balances'
      preLoaderRoute: typeof appMainLayoutBalancesBalancesRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_admin-layout/admin_/payments': {
      id: '/(app)/_admin-layout/admin_/payments'
      path: '/admin/payments'
      fullPath: '/admin/payments'
      preLoaderRoute: typeof appAdminLayoutAdminPaymentsRouteImport
      parentRoute: typeof appAdminLayoutRoute
    }
    '/(app)/_main-layout/_settings/settings/webhooks-callbacks': {
      id: '/(app)/_main-layout/_settings/settings/webhooks-callbacks'
      path: '/webhooks-callbacks'
      fullPath: '/settings/webhooks-callbacks'
      preLoaderRoute: typeof appMainLayoutSettingsSettingsWebhooksCallbacksRouteImport
      parentRoute: typeof appMainLayoutSettingsSettingsRoute
    }
    '/(app)/_main-layout/_settings/settings/users': {
      id: '/(app)/_main-layout/_settings/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof appMainLayoutSettingsSettingsUsersRouteImport
      parentRoute: typeof appMainLayoutSettingsSettingsRoute
    }
    '/(app)/_main-layout/_settings/settings/security': {
      id: '/(app)/_main-layout/_settings/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof appMainLayoutSettingsSettingsSecurityRouteImport
      parentRoute: typeof appMainLayoutSettingsSettingsRoute
    }
    '/(app)/_main-layout/_settings/settings/notifications': {
      id: '/(app)/_main-layout/_settings/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof appMainLayoutSettingsSettingsNotificationsRouteImport
      parentRoute: typeof appMainLayoutSettingsSettingsRoute
    }
    '/(app)/_main-layout/_settings/settings/institutions': {
      id: '/(app)/_main-layout/_settings/settings/institutions'
      path: '/institutions'
      fullPath: '/settings/institutions'
      preLoaderRoute: typeof appMainLayoutSettingsSettingsInstitutionsRouteImport
      parentRoute: typeof appMainLayoutSettingsSettingsRoute
    }
    '/(app)/_main-layout/_settings/settings/accounts': {
      id: '/(app)/_main-layout/_settings/settings/accounts'
      path: '/accounts'
      fullPath: '/settings/accounts'
      preLoaderRoute: typeof appMainLayoutSettingsSettingsAccountsRouteImport
      parentRoute: typeof appMainLayoutSettingsSettingsRoute
    }
    '/(app)/_main-layout/_settings/settings/account-settings': {
      id: '/(app)/_main-layout/_settings/settings/account-settings'
      path: '/account-settings'
      fullPath: '/settings/account-settings'
      preLoaderRoute: typeof appMainLayoutSettingsSettingsAccountSettingsRouteImport
      parentRoute: typeof appMainLayoutSettingsSettingsRoute
    }
    '/(app)/_main-layout/_payments/payments_/$paymentId': {
      id: '/(app)/_main-layout/_payments/payments_/$paymentId'
      path: '/payments/$paymentId'
      fullPath: '/payments/$paymentId'
      preLoaderRoute: typeof appMainLayoutPaymentsPaymentsPaymentIdRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_main-layout/_payments/payments/payout': {
      id: '/(app)/_main-layout/_payments/payments/payout'
      path: '/payout'
      fullPath: '/payments/payout'
      preLoaderRoute: typeof appMainLayoutPaymentsPaymentsPayoutRouteImport
      parentRoute: typeof appMainLayoutPaymentsPaymentsRoute
    }
    '/(app)/_main-layout/_payments/payments/payin': {
      id: '/(app)/_main-layout/_payments/payments/payin'
      path: '/payin'
      fullPath: '/payments/payin'
      preLoaderRoute: typeof appMainLayoutPaymentsPaymentsPayinRouteImport
      parentRoute: typeof appMainLayoutPaymentsPaymentsRoute
    }
    '/(app)/_main-layout/_pay-by-link/pay-by-link_/$paymentIntentId': {
      id: '/(app)/_main-layout/_pay-by-link/pay-by-link_/$paymentIntentId'
      path: '/pay-by-link/$paymentIntentId'
      fullPath: '/pay-by-link/$paymentIntentId'
      preLoaderRoute: typeof appMainLayoutPayByLinkPayByLinkPaymentIntentIdRouteImport
      parentRoute: typeof appMainLayoutRoute
    }
    '/(app)/_main-layout/_balances/balances/overview': {
      id: '/(app)/_main-layout/_balances/balances/overview'
      path: '/overview'
      fullPath: '/balances/overview'
      preLoaderRoute: typeof appMainLayoutBalancesBalancesOverviewRouteImport
      parentRoute: typeof appMainLayoutBalancesBalancesRoute
    }
    '/(app)/_admin-layout/admin_/payments_/$paymentId': {
      id: '/(app)/_admin-layout/admin_/payments_/$paymentId'
      path: '/admin/payments/$paymentId'
      fullPath: '/admin/payments/$paymentId'
      preLoaderRoute: typeof appAdminLayoutAdminPaymentsPaymentIdRouteImport
      parentRoute: typeof appAdminLayoutRoute
    }
    '/(app)/_admin-layout/admin_/merchants_/$merchantId': {
      id: '/(app)/_admin-layout/admin_/merchants_/$merchantId'
      path: '/admin/merchants/$merchantId'
      fullPath: '/admin/merchants/$merchantId'
      preLoaderRoute: typeof appAdminLayoutAdminMerchantsMerchantIdRouteImport
      parentRoute: typeof appAdminLayoutRoute
    }
  }
}

interface appAdminLayoutRouteChildren {
  appAdminLayoutAdminRoute: typeof appAdminLayoutAdminRoute
  appAdminLayoutAdminPaymentsRoute: typeof appAdminLayoutAdminPaymentsRoute
  appAdminLayoutAdminMerchantsMerchantIdRoute: typeof appAdminLayoutAdminMerchantsMerchantIdRoute
  appAdminLayoutAdminPaymentsPaymentIdRoute: typeof appAdminLayoutAdminPaymentsPaymentIdRoute
}

const appAdminLayoutRouteChildren: appAdminLayoutRouteChildren = {
  appAdminLayoutAdminRoute: appAdminLayoutAdminRoute,
  appAdminLayoutAdminPaymentsRoute: appAdminLayoutAdminPaymentsRoute,
  appAdminLayoutAdminMerchantsMerchantIdRoute:
    appAdminLayoutAdminMerchantsMerchantIdRoute,
  appAdminLayoutAdminPaymentsPaymentIdRoute:
    appAdminLayoutAdminPaymentsPaymentIdRoute,
}

const appAdminLayoutRouteWithChildren = appAdminLayoutRoute._addFileChildren(
  appAdminLayoutRouteChildren,
)

interface appMainLayoutBalancesBalancesRouteChildren {
  appMainLayoutBalancesBalancesOverviewRoute: typeof appMainLayoutBalancesBalancesOverviewRoute
}

const appMainLayoutBalancesBalancesRouteChildren: appMainLayoutBalancesBalancesRouteChildren =
  {
    appMainLayoutBalancesBalancesOverviewRoute:
      appMainLayoutBalancesBalancesOverviewRoute,
  }

const appMainLayoutBalancesBalancesRouteWithChildren =
  appMainLayoutBalancesBalancesRoute._addFileChildren(
    appMainLayoutBalancesBalancesRouteChildren,
  )

interface appMainLayoutPaymentsPaymentsRouteChildren {
  appMainLayoutPaymentsPaymentsPayinRoute: typeof appMainLayoutPaymentsPaymentsPayinRoute
  appMainLayoutPaymentsPaymentsPayoutRoute: typeof appMainLayoutPaymentsPaymentsPayoutRoute
}

const appMainLayoutPaymentsPaymentsRouteChildren: appMainLayoutPaymentsPaymentsRouteChildren =
  {
    appMainLayoutPaymentsPaymentsPayinRoute:
      appMainLayoutPaymentsPaymentsPayinRoute,
    appMainLayoutPaymentsPaymentsPayoutRoute:
      appMainLayoutPaymentsPaymentsPayoutRoute,
  }

const appMainLayoutPaymentsPaymentsRouteWithChildren =
  appMainLayoutPaymentsPaymentsRoute._addFileChildren(
    appMainLayoutPaymentsPaymentsRouteChildren,
  )

interface appMainLayoutSettingsSettingsRouteChildren {
  appMainLayoutSettingsSettingsAccountSettingsRoute: typeof appMainLayoutSettingsSettingsAccountSettingsRoute
  appMainLayoutSettingsSettingsAccountsRoute: typeof appMainLayoutSettingsSettingsAccountsRoute
  appMainLayoutSettingsSettingsInstitutionsRoute: typeof appMainLayoutSettingsSettingsInstitutionsRoute
  appMainLayoutSettingsSettingsNotificationsRoute: typeof appMainLayoutSettingsSettingsNotificationsRoute
  appMainLayoutSettingsSettingsSecurityRoute: typeof appMainLayoutSettingsSettingsSecurityRoute
  appMainLayoutSettingsSettingsUsersRoute: typeof appMainLayoutSettingsSettingsUsersRoute
  appMainLayoutSettingsSettingsWebhooksCallbacksRoute: typeof appMainLayoutSettingsSettingsWebhooksCallbacksRoute
}

const appMainLayoutSettingsSettingsRouteChildren: appMainLayoutSettingsSettingsRouteChildren =
  {
    appMainLayoutSettingsSettingsAccountSettingsRoute:
      appMainLayoutSettingsSettingsAccountSettingsRoute,
    appMainLayoutSettingsSettingsAccountsRoute:
      appMainLayoutSettingsSettingsAccountsRoute,
    appMainLayoutSettingsSettingsInstitutionsRoute:
      appMainLayoutSettingsSettingsInstitutionsRoute,
    appMainLayoutSettingsSettingsNotificationsRoute:
      appMainLayoutSettingsSettingsNotificationsRoute,
    appMainLayoutSettingsSettingsSecurityRoute:
      appMainLayoutSettingsSettingsSecurityRoute,
    appMainLayoutSettingsSettingsUsersRoute:
      appMainLayoutSettingsSettingsUsersRoute,
    appMainLayoutSettingsSettingsWebhooksCallbacksRoute:
      appMainLayoutSettingsSettingsWebhooksCallbacksRoute,
  }

const appMainLayoutSettingsSettingsRouteWithChildren =
  appMainLayoutSettingsSettingsRoute._addFileChildren(
    appMainLayoutSettingsSettingsRouteChildren,
  )

interface appMainLayoutRouteChildren {
  appMainLayoutBalancesBalancesRoute: typeof appMainLayoutBalancesBalancesRouteWithChildren
  appMainLayoutExchangeExchangeRoute: typeof appMainLayoutExchangeExchangeRoute
  appMainLayoutPayByLinkPayByLinkRoute: typeof appMainLayoutPayByLinkPayByLinkRoute
  appMainLayoutPaymentsPaymentsRoute: typeof appMainLayoutPaymentsPaymentsRouteWithChildren
  appMainLayoutSettingsSettingsRoute: typeof appMainLayoutSettingsSettingsRouteWithChildren
  appMainLayoutDashboardIndexRoute: typeof appMainLayoutDashboardIndexRoute
  appMainLayoutPayByLinkPayByLinkPaymentIntentIdRoute: typeof appMainLayoutPayByLinkPayByLinkPaymentIntentIdRoute
  appMainLayoutPaymentsPaymentsPaymentIdRoute: typeof appMainLayoutPaymentsPaymentsPaymentIdRoute
}

const appMainLayoutRouteChildren: appMainLayoutRouteChildren = {
  appMainLayoutBalancesBalancesRoute:
    appMainLayoutBalancesBalancesRouteWithChildren,
  appMainLayoutExchangeExchangeRoute: appMainLayoutExchangeExchangeRoute,
  appMainLayoutPayByLinkPayByLinkRoute: appMainLayoutPayByLinkPayByLinkRoute,
  appMainLayoutPaymentsPaymentsRoute:
    appMainLayoutPaymentsPaymentsRouteWithChildren,
  appMainLayoutSettingsSettingsRoute:
    appMainLayoutSettingsSettingsRouteWithChildren,
  appMainLayoutDashboardIndexRoute: appMainLayoutDashboardIndexRoute,
  appMainLayoutPayByLinkPayByLinkPaymentIntentIdRoute:
    appMainLayoutPayByLinkPayByLinkPaymentIntentIdRoute,
  appMainLayoutPaymentsPaymentsPaymentIdRoute:
    appMainLayoutPaymentsPaymentsPaymentIdRoute,
}

const appMainLayoutRouteWithChildren = appMainLayoutRoute._addFileChildren(
  appMainLayoutRouteChildren,
)

interface appRouteChildren {
  appAdminLayoutRoute: typeof appAdminLayoutRouteWithChildren
  appMainLayoutRoute: typeof appMainLayoutRouteWithChildren
}

const appRouteChildren: appRouteChildren = {
  appAdminLayoutRoute: appAdminLayoutRouteWithChildren,
  appMainLayoutRoute: appMainLayoutRouteWithChildren,
}

const appRouteWithChildren = appRoute._addFileChildren(appRouteChildren)

interface AuthAuthLayoutRouteChildren {
  AuthAuthLayoutForgotPasswordRoute: typeof AuthAuthLayoutForgotPasswordRoute
  AuthAuthLayoutSigninRoute: typeof AuthAuthLayoutSigninRoute
  AuthAuthLayoutSignupRoute: typeof AuthAuthLayoutSignupRoute
  AuthAuthLayoutResetPasswordTokenRoute: typeof AuthAuthLayoutResetPasswordTokenRoute
  AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRoute: typeof AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRoute
  AuthAuthLayoutSignupSuccessRoute: typeof AuthAuthLayoutSignupSuccessRoute
  AuthAuthLayoutVerifyOtpOtpRequestIdRoute: typeof AuthAuthLayoutVerifyOtpOtpRequestIdRoute
}

const AuthAuthLayoutRouteChildren: AuthAuthLayoutRouteChildren = {
  AuthAuthLayoutForgotPasswordRoute: AuthAuthLayoutForgotPasswordRoute,
  AuthAuthLayoutSigninRoute: AuthAuthLayoutSigninRoute,
  AuthAuthLayoutSignupRoute: AuthAuthLayoutSignupRoute,
  AuthAuthLayoutResetPasswordTokenRoute: AuthAuthLayoutResetPasswordTokenRoute,
  AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRoute:
    AuthAuthLayoutSetTwoFactorTwoFactorRequestIdRoute,
  AuthAuthLayoutSignupSuccessRoute: AuthAuthLayoutSignupSuccessRoute,
  AuthAuthLayoutVerifyOtpOtpRequestIdRoute:
    AuthAuthLayoutVerifyOtpOtpRequestIdRoute,
}

const AuthAuthLayoutRouteWithChildren = AuthAuthLayoutRoute._addFileChildren(
  AuthAuthLayoutRouteChildren,
)

interface AuthRouteChildren {
  AuthAuthLayoutRoute: typeof AuthAuthLayoutRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAuthLayoutRoute: AuthAuthLayoutRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AboutRoute: AboutRoute,
  ErrorRoute: ErrorRoute,
  appRoute: appRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
